import { LearningPath } from '@/types/learning-path';
import { Icon } from '@iconify/react';
import { Card } from '@nextui-org/react';
import { useNavigate, useParams } from 'react-router-dom';

interface LearningPathCardProps {
  path: LearningPath;
}

const LearningPathCard = ({ path }: LearningPathCardProps) => {
  const navigate = useNavigate();
  const { tenantSlug } = useParams<{ tenantSlug: string }>();

  return (
    <Card
      isPressable
      className="p-6 cursor-pointer hover:bg-default-100 transition-colors"
      onPress={() => {
        navigate(`/${tenantSlug}/learning-paths/${path.id}/edit`);
      }}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-lg font-semibold">{path.name}</h3>
          {path.description && (
            <p className="text-sm text-default-500 mt-1">{path.description}</p>
          )}
        </div>
        <div className="flex items-center gap-2">
          <span
            className={`text-xs px-2 py-1 rounded-full ${
              path.status === 'PUBLISHED'
                ? 'bg-success-100 text-success-600'
                : 'bg-default-100 text-default-600'
            }`}
          >
            {path.status.charAt(0).toUpperCase() + path.status.slice(1)}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4 mt-4 text-sm text-default-500">
        <div className="flex items-center gap-1">
          <Icon icon="lucide:users" className="w-4 h-4" />
          <span>{path.prompts?.length || 0} Agents</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon icon="lucide:calendar" className="w-4 h-4" />
          <span>
            Updated{' '}
            {new Date(path.updated_at).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <Icon icon="lucide:user" className="w-4 h-4" />
          <span>{path.created_by.email}</span>
        </div>
      </div>
    </Card>
  );
};

LearningPathCard.displayName = 'LearningPathCard';

export { LearningPathCard };
